import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// diğer importlar
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

import baseApi from "../../api/baseApi";
const loginApi = "https://api.globalyolyardim.com";

const initialState = {
  isUserData: null,
  authCheckLoading: true,
  authCheckRefresh: true,

  registerLoading: false,
  forgotPasswordLoading: false,
  phoneCodeCheckLoading: false,
  emailCodeCheckLoading: false,
  resetPasswordLoading: false,
  registerCustomerLoading: false,

  customer: {},
  customerLoading: true,
  customerRefresh: true,

  // login
  user: {},
  error: "", // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
};

export const loginUser = (user, history) => async (dispatch) => {
  dispatch(loadingStart());

  const handleLogin = () => {
    axios
      .post(`${loginApi}/Account/CustomerLogin`, user)
      .then(async (response) => {
        const responseData = {
          data: response.data.Value,
          status: "success",
          token: response.data.Value.AccessToken,
        };

        localStorage.setItem("authUser", JSON.stringify(responseData));
        history("/dashboard");
        dispatch(loginSuccess(responseData));
      })
      .catch((err) => {
        dispatch(
          apiError(
            err?.response ? err.response.data.Error.Description : err.message
          )
        );
      });
  };
  try {
    handleLogin();
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    localStorage.removeItem("authUser");
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const authCheck = createAsyncThunk("auth/authCheck", async () => {
  const user = localStorage.getItem("authUser");

  try {
    const response = await baseApi.get(`/Account/AuthCheck`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(user).token}`,
      },
    });

    return response.data.Value;
  } catch (error) {
    throw new Error(error);
  }
});

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (phoneNumber) => {
    if (!phoneNumber) throw new Error("Telefon numarası bulunamadı!");

    const loadingToast = toast.loading("Lütfen bekleyin...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(
        `/Account/CustomerForgotPassword?phoneNumber=${phoneNumber}`
      );

      toast.update(loadingToast, {
        render: "Şifreniz SMS ile gönderildi.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: error?.response.data?.Error
          ? `Hata: ${error.response.data.Error.Description}`
          : "Hata: Diğer hatalar!",
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const fetchCustomerUserId = createAsyncThunk(
  "auth/fetchCustomerUserId",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    try {
      const response = await baseApi.get(
        `/Account/GetCustomerInfo?userId=${id}`
      );

      return response.data.Value;
    } catch (error) {
      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const registerCustomer = createAsyncThunk(
  "auth/registerCustomer",
  async (values) => {
    if (!values) {
      throw new Error("Veri bulunamadı!");
    }

    const data = {
      id: 0,
      customerName: values.customerName,
      phoneNumber: values.phoneNumber,
      email: values.email,
      isActive: true,
      taxNumber: values.taxNumber,
      taxOffice: values.taxOffice,
      city: values.city,
      district: values.district,
      address: values.address,
      agencyId: 0,
    };

    const loadingToast = toast.loading("Lütfen bekleyin...", {
      position: "top-center",
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Account/RegisterCustomer`, data);

      toast.update(loadingToast, {
        render: "Kayıt Başarılı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      return response.data.Value;
    } catch (error) {
      toast.update(loadingToast, {
        render: "Hata: " + error.response.data.Error.Description,
        type: "error",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
      });

      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    logoutUserSuccess(state) {
      state.isUserLogout = true;
    },
    loadingStart(state) {
      state.loading = true;
    },
    reset_login_flag(state) {
      state.error = null;
      state.loading = false;
      state.errorMsg = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(authCheck.pending, (state, action) => {
        state.isUserData = null;
        state.authCheckLoading = true;
      })
      .addCase(authCheck.fulfilled, (state, action) => {
        state.isUserData = action.payload;
        state.authCheckLoading = false;
      })
      .addCase(authCheck.rejected, (state, action) => {
        state.isUserData = null;
        state.authCheckLoading = false;
      });

    builder
      .addCase(forgotPassword.pending, (state, action) => {
        state.forgotPasswordLoading = true;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.forgotPasswordLoading = false;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.forgotPasswordLoading = false;
      });

    builder
      .addCase(registerCustomer.pending, (state, action) => {
        state.registerCustomerLoading = true;
      })
      .addCase(registerCustomer.fulfilled, (state, action) => {
        state.registerCustomerLoading = false;
      })
      .addCase(registerCustomer.rejected, (state, action) => {
        state.registerCustomerLoading = false;
      });

    builder
      .addCase(fetchCustomerUserId.pending, (state, action) => {
        state.customer = {};
        state.customerLoading = true;
      })
      .addCase(fetchCustomerUserId.fulfilled, (state, action) => {
        state.customer = action.payload;
        state.customerLoading = false;
      })
      .addCase(fetchCustomerUserId.rejected, (state, action) => {
        state.customer = {};
        state.customerLoading = false;
      });
  },
});

export const {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
  loadingStart,
} = authSlice.actions;

export default authSlice.reducer;
